import { useAppStore } from "@/stores/appStore";
import { forwardRef, Suspense } from "react";
import * as THREE from "three";
import Door from "./Door";
import Pillar from "./Pillar/Pillar";
import useMaterial from "@/hooks/useMaterial";
import { config_base } from "@/data/config_base";

interface GateGroupProps {
	scale?: [number, number, number];
	position?: [number, number, number];
	rotation?: [number, number, number];
	pillarPosition?: string;
}

// Function for creating and rotating Gate components
const GateGroup = forwardRef<THREE.Group, GateGroupProps>(({ scale, position, pillarPosition }, ref) => {
	const { gate } = useAppStore((state) => state.configurator);
	const minGap = 0.008;

	return (
		<group ref={ref} rotation={[0, 0, 0]} scale={scale} position={position}>
			<Door
				minGap={minGap}
				plankWidth={gate.selectedDimensions.door_plank_width / 500}
				doorWidth={gate.selectedDimensions.door_width / 500}
				centerHeight={gate.selectedDimensions.center_height / 500}
				outerHeight={gate.selectedDimensions.outer_height / 500}
				frameWidth={gate.selectedDimensions.door_frame_width / 500}
				doorFrameThickness={gate.selectedDimensions.door_frame_thickness / 500}
				doorPlankThickness={gate.selectedDimensions.door_plank_width / 500}
				pillarPosition={pillarPosition}
			/>
			<Pillar
				doorWidth={gate.selectedDimensions.door_width / 500}
				centerHeight={gate.selectedDimensions.center_height / 500}
				outerHeight={gate.selectedDimensions.outer_height / 500}
				pillarDimensions={{
					pillarWidth: 0.15,
					pillarLength: 0.15,
				}}
				pillarPosition={pillarPosition}
			/>
		</group>
	);
});

GateGroup.displayName = "GateGroup";

export default function Gate() {
	return (
		<>
			<GateGroup pillarPosition={"right"} rotation={[0, 0, 0]} />
			<GateGroup pillarPosition={"left"} scale={[-1, 1, 1]} />
		</>
	);
}
